import { SmartMeterEligibilityReasonEnum } from "@/api/backofficeRest/generated/model"
import { ISmartMeterEligibility } from "./smartMeterEligibility.types"
import {
  meterAppointmentTypeValues,
  MeterAppointmentType,
} from "@/constants/imbp"

export class SmartMeterEligibility implements ISmartMeterEligibility {
  reason: SmartMeterEligibilityReasonEnum
  meterOperatorCode: string | null

  constructor(
    reason: SmartMeterEligibilityReasonEnum,
    meterOperatorCode: string | null = null,
  ) {
    this.reason = reason
    this.meterOperatorCode = meterOperatorCode
  }

  get meterInstallationType(): MeterAppointmentType | null {
    switch (this.reason) {
      case SmartMeterEligibilityReasonEnum.ELIGIBLE_ELEC_EXCHANGE:
        return meterAppointmentTypeValues.ELEC_ONLY
      case SmartMeterEligibilityReasonEnum.ELIGIBLE_GAS_EXCHANGE:
        return meterAppointmentTypeValues.GAS_ONLY
      case SmartMeterEligibilityReasonEnum.ELIGIBLE_DUAL_EXCHANGE:
        return meterAppointmentTypeValues.DUAL
      default:
        return null
    }
  }

  get isEligible(): boolean {
    return this.eligibleForGasExchange || this.eligibleForElectricExchange
  }

  get hasComplexMeterSetup(): boolean {
    return (
      this.reason === SmartMeterEligibilityReasonEnum.INELIGIBLE_TOO_COMPLEX
    )
  }

  get hasMopDiscrepancy(): boolean {
    return (
      this.reason === SmartMeterEligibilityReasonEnum.INELIGIBLE_MOP_DISCREPANCY
    )
  }

  get eligibleForGasExchange(): boolean {
    return (
      this.meterInstallationType === meterAppointmentTypeValues.GAS_ONLY ||
      this.meterInstallationType === meterAppointmentTypeValues.DUAL
    )
  }

  get eligibleForElectricExchange(): boolean {
    return (
      this.meterInstallationType === meterAppointmentTypeValues.ELEC_ONLY ||
      this.meterInstallationType === meterAppointmentTypeValues.DUAL
    )
  }
}
